module.exports = __webpack_public_path__ + "static/media/bag.072ea1b3.png";